module.exports = __webpack_public_path__ + "assets/img/gfpd2.852214d1.png";